<template>
    <div v-if="task != null">
        <!-- <router-link :to="/"> ← Examples index</router-link> -->
        <div class="flex items-center bg-nord4 br2 pa3">
            <router-link to="/" class="nord0 mr3 dim"> 
                <i class="fa fa-arrow-left fa-lg" aria-hidden="true"></i>
            </router-link>
            <h3 class="f3 mv0">{{task.text}}</h3>
            <div class="f3 br2 ml3 ba b--transparent bw1 bg-nord6 ph3 pv1 b">
                {{totalTime}} 
            </div>
        </div>
        <div v-if="task.children.length > 0">
            <div>
                <div>
                    <h3 class="mv3 f3">Tags</h3>
                    <router-link :to="'/stats/'+this.id" @click="tag = ''" class="mh2 dib ttu link nord0 b pointer grow pv2">
                        <span class="bg-nord4 pv1 ph2 dib br2" :class="{'bg-nord7': tag == ''}">All</span>
                    </router-link>
                    <span class="dib mh2 pointer grow pv2" v-for="tagName in task.getTags()" :key="tagName">
                        <router-link 
                            :to="computedUrl + tagName" 
                            :class="{'bg-nord7': tag == tagName}" 
                            class="nord0 bg-nord4 pv1 ph2 dib br2 link b"> #{{tagName}} </router-link>
                    </span>
                </div>
                <vue-frappe
                    id="seven-day"
                    type="bar"
                    :key="graph.update"
                    :labels="graph.labels"
                    :height="300"
                    :barOptions="{ stacked: 1 }"
                    :tooltipOptions="{ formatTooltipX: d => (d + '').toUpperCase(), formatTooltipY: d => niceTime(d)}"
                    :colors="['#8FBCBB', '#BF616A', '#D08770', '#EBCB8B', '#A3BE8C', '#B48EAD']"
                    :dataSets="graph.datasets">
                </vue-frappe>
            </div>
        </div>
        <div v-else class="vh-50 flex flex-column items-center justify-center w-100">
            <i class="fa fa-frown-o fa-4x" aria-hidden="true"></i>
            <h3 class="tc f3 nord2 o-80 mb2">
                This task has no sub-tasks! 
            </h3>
            <p class="tc">
                Add some to get a breakdown between them
            </p>
        </div>
    </div>
</template>
<script>
import {msToTime, niceTime} from "../util/format.js"
export default {
    data () {
        return {
            task: null,
        }
    },
    methods: {
        niceTime: niceTime,
        tagSelect(tag) {
            alert("The tag clicked is " + tag);
        }
    },
    computed: {
        graph(){
            return (this.tag == '') ? this.task.frappe() : this.task.frappe(false, this.tag)
        },
        computedUrl(){
            return "/stats/" + this.id + "/tag/"
        },
        totalTime(){
            let times = (this.tag == '') ? this.task.breakdown() : this.task.breakdown(this.tag)
            console.log("Times is: " + times)
            return msToTime(times.reduce((a, b) => a + b, 0) * 1000)
        }
    },
    watch: {
        id: {
            handler(){
                this.task = this.$root.tasks.getChild(this.id)
            },
            immediate: true
        }
    },
    props: ["tag", "id"]
}
</script>
